<template>
  <div id="switch-trip">
    <div class="buisness-travel df-jsb-aic" :class="{ 'mt2': !isPhone }">
      <h3 class="raleway-semi-p13 mb-0">
        Accessible aux PMR <span v-if="getFilterCount()" class="filter-count">({{ getFilterCount() }})</span>
      </h3>
      <input type="checkbox" id="accessible-pmr" v-model="selected" /><label for="accessible-pmr">Accessible aux PMR</label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'switch-pmr',
  props: ['filterCounts'],
  data() {
    return {
      selected: false,
    };
  },
  methods: {
    getFilterCount() {
      if (!this.filterCounts || !this.filterCounts.has_pmr_access) return 0;
      const pmrData = this.filterCounts.has_pmr_access.find((item) => item.key === 1 || item.key === true || item.key === 'true');
      return pmrData ? pmrData.count : 0;
    },
  },
  watch: {
    selected(val) {
      this.$emit('checked', val, 'pmr_access');
    },
  },
  computed: {
    isPhone() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scope="app/assets/stylesheets/components/lodging-filter">
.filter-count {
  color: #666;
  font-size: 0.9em;
  font-weight: normal;
  margin-left: 4px;
}
</style>
